import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Card } from './Card';

export interface ListingBaseCardProps {
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  to?: string;
}

export const ListingBaseCard: React.FC<ListingBaseCardProps> = ({
  className,
  children,
  onClick,
  to,
}) => {
  const containerClasses = twMerge('flex flex-col gap-6 h-full p-3 pb-7.5', className);
  return (
    <Card to={to} className={containerClasses} onClick={onClick}>
      {children}
    </Card>
  );
};
